import React, { useState, useEffect } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { useDispatch, useSelector } from "react-redux";
import { ActiveCell, EditCommandCell, SignatureCell } from "../GridComponents";
import { editSource, getSources } from "actions/sources.action";
import AddEditSource from "./AddEditSource";

const SourcesList = () => {
  const [isEditFormOpen, setIsEditFormOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const dispatch = useDispatch();
  const { sourcesList, isLoading } = useSelector((state) => state.sources);

  useEffect(() => {
    dispatch(getSources());
  }, []);

  const enterEdit = (item) => {
    setIsEditFormOpen(true);
    setEditItem(item);
  };

  const handleSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const dataToPost = {
        data: {
          ...data,
          active: data.active ?? true,
        },
      };
      await dispatch(editSource(data.sourceID, dataToPost));
      setIsEditFormOpen(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancelEdit = () => {
    setIsEditFormOpen(false);
    setEditItem(null);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  const loadingPanel = (
    <div className="k-loading-mask">
      <span className="k-loading-text">Loading</span>
      <div className="k-loading-image"></div>
      <div className="k-loading-color"></div>
    </div>
  );

  return (
    <div className="settings-grid-wrapper">
      <div className="settings-grid">
        {isLoading && loadingPanel}
        <Grid data={sourcesList?.data || []}>
          <Column
            field="sourceName"
            title=" "
            cell={(props) => <SignatureCell {...props} />}
          />
          <Column field="sourceName" title="Name" width="200px" />
          <Column field="sourceDetails" title="Details" />
          <Column
            cell={ActiveCell}
            title="Active"
            field="active"
            width="80px"
          />
          <Column title="Edit" cell={MyEditCommandCell} width="60px" />
        </Grid>

        {isEditFormOpen && (
          <AddEditSource
            cancelEdit={handleCancelEdit}
            onSubmit={handleSubmit}
            item={editItem}
            type="edit"
            isSubmitting={isSubmitting}
          />
        )}
      </div>
    </div>
  );
};

export default SourcesList;
